<app-tablepage-base [loading]="loading">

  <!-- 1. LA TABELLA (Dichiarata semplicemente con scrollHeight="100%") -->
  <p-table [value]="users"
           [paginator]="true" [rows]="25"
           [scrollable]="true" scrollHeight="flex"
           [globalFilterFields]="['userId', 'firstName', 'lastName', 'userName', 'isActive']"
           stripedRows
           #dt
           class="flex h-full min-h-0 flex-col">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">{{ 'titles.listUsers' | translate }}</span>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="{{ 'search' | translate }}..." />
          </div>
          <p-button variant="outlined" icon="pi pi-user-plus" [label]="'newUser' | translate" (click)="onShowDialog(newUser)" />
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th>{{ 'surname' | translate }}</th>
        <th>{{ 'name' | translate }}</th>
        <th>E-Mail</th>
        <th>{{ 'status' | translate }}</th>
        <th>
          <div class="flex items-center justify-center">
            {{ 'role' | translate }}
          </div>
        </th>
        <th style="width:5%"></th>
        <th style="width:5%"></th>
      </tr>
    </ng-template>
    <ng-template #body let-user>
      <tr [pSelectableRow]="user" app-user-row [user]="user" [isShowing]="isShowing" [maxRole]="maxRole"
                                               (deleteRequest)="onDelete($event)" (showRequest)="onShowDialog($event)">
      </tr>
    </ng-template>
  </p-table>

  <!-- 2. DIALOG (Posizionata fuori dal flusso, non rompe il layout) -->
  <app-user-dialog [isNew]="isNew"
                   [messageService]="messageService"
                   [(visible)]="showDialog"
                   [user]="selectedUser"
                   (saved)="onUserSaved($event)">
  </app-user-dialog>
</app-tablepage-base>
